import { render, staticRenderFns } from "./DetailedLedgerReport.vue?vue&type=template&id=44fd780d&scoped=true"
import script from "./DetailedLedgerReport.vue?vue&type=script&lang=js"
export * from "./DetailedLedgerReport.vue?vue&type=script&lang=js"
import style0 from "./DetailedLedgerReport.vue?vue&type=style&index=0&id=44fd780d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fd780d",
  null
  
)

export default component.exports